'use strict';

export default {
  perfDebug: false,
  api: '/api',
  maxNotificationsNum: 1,
  localDataCompress: false,
  requestTimeout: 5000,
  testBaseUrl: '/tests/',
  storeTrackingsOffline: true,
  requestsQueueTimeout: 5000,
  requestsQueueMaxRetries: 5,
  requestsQueueNetworkMaxWaitInterval: 16000,
  requestQueuePermanentWaitInterval: 2000,
  requestsQueueTemporaryErrorMaxWaitInterval: 16000,
  maxPermanentsErrorsBackupSize: 20,
  useBeacon: true
};
